export default __webpack_public_path__ + "static/media/home-creative-portfolio-img-06.aa6f4397.jpg";